let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lnHpS")).then(() => parcelRequire('edoS5'));